
export const update_areaOption = 'update_areaOption';

export const update_scoreItem = 'update_scoreItem';

export const update_device = 'update_device';

export const update_isCollapse = 'update_isCollapse';

export const update_cachedViews = 'update_cachedViews';